import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Layout,
  Modal,
  Button,
  Row,
  Col,
  Space,
  Typography,
  Popover,
  Avatar,
  Divider,
} from 'antd';
import {
  MenuFoldOutlined,
  ExclamationCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { isMobile } from 'react-device-detect';
// actions
import { getOperator, logout } from '../redux/actions/AuthActions';
import AppDrawer from './AppDrawer';
import { injectIntl } from 'react-intl';
import { debounce } from 'lodash';
import orderApi from '../api/order';
import dayjs from 'dayjs';
import cacheApi from '../api/cache';
import {
  Link,
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom';
import { getLabelMenu } from '../helpers/helpers';
import menu from '../menu';
import { GET_AUTH_USER, GET_OPERATOR } from '../redux/types';
import IntlMessages from '../components/IntlMessage';
import { withRouter } from 'react-router-dom';

const { Text } = Typography;
const { Header } = Layout;
const { confirm } = Modal;

function AppHeader() {
  const [visible, setVisible] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const authUser = useSelector((state) => state.auth.authUser);
  const account = useSelector((state) => state.auth.operator);
  const accountTitle =
    account?.title ||
    authUser?.operator?.title ||
    authUser?.userOperator?.operator?.title ||
    authUser?.collaborator?.operator?.title ||
    authUser?.userOperator?.title ||
    authUser?.collaborator?.title;
  // const config = useSelector((state) => state.config);
  const dispatch = useDispatch();
  const isMount = useRef(false);
  const [loadingCache, setLoadingCache] = useState(false);
  const [total, setTotal] = useState(1);
  const history = useHistory();
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });
  const { pathname } = useLocation();

  const toggleDrawer = (visible) => {
    setVisible(visible);
  };

  useEffect(() => {
    isMount.current = true;

    function fetchData() {
      if (isMount) {
        dispatch(getOperator());
      }
    }
    fetchData();

    return () => {
      isMount.current = false;
    };
  }, [dispatch]);

  const onLogout = () => {
    confirm({
      title: 'Are you sure to log out?',
      icon: <ExclamationCircleOutlined />,
      okText: 'OK',
      cancelText: 'Cancel',
      onOk: () => {
        dispatch(logout()).then(() => {
          window.location.href = '/login';
        });
      },
    });
  };

  const prefix = (
    <SearchOutlined
      style={{
        fontSize: 16,
        color: '#1890ff',
      }}
    />
  );

  const handleChangeSearch = debounce(async (e) => {
    setFilter((filter) => {
      return { ...filter, keyword: e.target.value };
    });
  }, 300);

  const onChangePagination = (page, pageSize) => {
    // console.log(pageSize);
    setFilter({
      ...filter,
      page,
      limit: pageSize,
    });
  };

  const onClose = () => {
    setIsSearching(false);
  };

  const onFocus = debounce(() => {
    if (filter.keyword?.length > 1) {
      if (!isSearching) {
        setIsSearching(true);
      }
    } else {
      setIsSearching(false);
    }
  }, 500);

  const handleResetCache = () => {
    setLoadingCache(true);
    cacheApi
      .reset()
      .then(() => {
        setLoadingCache(false);
      })
      .catch((error) => {
        console.error(error);
        setLoadingCache(false);
      });
  };

  return (
    <Header
      style={{ position: 'sticky', padding: isMobile ? '0 8px' : '16px' }}
      className="site-header-background">
      <Row justify="space-between">
        <Col>
          {/* <img
            style={{ height: '30px', width: 'auto', cursor: 'pointer' }}
            src={require('../assets/img/logo-icon1.png').default}
            alt="Logo"
            onClick={() => {
              history.push('/');
            }}
          /> */}
        </Col>

        <Col>
          <Text className="header_page-title">
            {getLabelMenu(menu, pathname || '/app')}
          </Text>
          {accountTitle && (
            <Text className="company-title">{accountTitle}</Text>
          )}
        </Col>
        <Col>
          <Row align="middle" justify="space-between">
            <Col>
              {/* <Divider type="vertical" style={{ height: '1.5em' }}></Divider> */}

              {/* <Button
                type="primary"
                shape="default"
                icon={
                  <MenuFoldOutlined
                    // style={{ fontSize: '30px' }}
                    className="header-icons"
                  />
                }
                onClick={() => toggleDrawer(true)}
              /> */}

              <React.Fragment>
                <Popover
                  trigger="click"
                  className="header-actions"
                  placement="bottomRight"
                  content={
                    <>
                      <Row gutter={[20, 20]}>
                        <Col>
                          <Row align="middle" justify="space-around">
                            {authUser.image ? (
                              <Avatar src={authUser.image} />
                            ) : (
                              <Avatar style={{ backgroundColor: '#f56a00' }}>
                                {authUser?.fullname?.charAt(0) ||
                                  authUser?.firstname?.charAt(0) +
                                    authUser?.lastname?.charAt(0)}
                              </Avatar>
                            )}
                          </Row>
                        </Col>
                        <Col>
                          <Text strong>{authUser?.fullname}</Text>
                          <br></br>
                          <Text style={{ fontSize: '12px' }} type="secondary">
                            {authUser.email}
                          </Text>
                        </Col>
                      </Row>
                      <Divider
                        style={{ marginTop: '10px', marginBottom: '10px' }}
                      />
                      <Link to="/app/settings/account">
                        <Button type="link">
                          <IntlMessages id="global.account_information" />
                        </Button>
                      </Link>
                      <Divider
                        style={{ marginTop: '10px', marginBottom: '10px' }}
                      />
                      <Button type="link" onClick={() => onLogout()}>
                        <Space>
                          <IntlMessages id="global.signout" />
                        </Space>
                      </Button>
                    </>
                  }
                  title={null}>
                  {authUser.image ? (
                    <Avatar src={authUser.image} />
                  ) : (
                    <Avatar style={{ backgroundColor: '#f56a00' }}>
                      {authUser?.fullname?.charAt(0)}
                    </Avatar>
                  )}
                </Popover>
              </React.Fragment>
            </Col>
          </Row>
        </Col>
      </Row>

      <AppDrawer visible={visible} onClose={() => toggleDrawer(false)} />
    </Header>
  );
}

// const OrderItem = (props) => {
//   const { order } = props;
//   return (
//     <Row>
//       <Col span={8}>
//         <Text type={order.roundtrip && 'success'}>
//           {order?.hop?.start_stop?.title} - {order?.hop?.end_stop?.title}
//         </Text>
//       </Col>
//       <Col span={8}>
//         <Space direction="vertical">
//           <Text>{dayjs(order.date).format('ddd, MMM DD, YYYY')}</Text>
//           {order?.return_date && (
//             <Text>{dayjs(order.return_date).format('ddd, MMM DD, YYYY')}</Text>
//           )}
//         </Space>
//       </Col>
//       <Col span={8}>
//         <Text>
//           {order?.customer?.fullname}
//           {order?.customer?.company_shortname &&
//             ` (${order?.customer?.company_shortname})`}
//         </Text>
//       </Col>
//     </Row>
//   );
// };

export default injectIntl(withRouter(AppHeader));
